// extracted by mini-css-extract-plugin
export default {"headerContainer":"insights_headerContainer__QRwnY","bestSellingHeader":"insights_bestSellingHeader__xwmDY"};